import React from 'react';
import { object, func } from 'prop-types';
import { translate } from 'react-i18next';

import styles from './THBankTransfer.scss';

const THBankTransfer = ({ selectedPlan, selectedPayment, t }) => {
  const { name } = selectedPlan;
  const { price } = selectedPayment;

  return (
    <div className={styles.root}>
      <div className={styles.rows}>
        <h5 className={styles.title}>
          {t('purchase.bankTransfer.packageDetails.title')}
        </h5>
        <h5 className={styles.title}>{name}</h5>
        <div className={styles.content}>
          <p>{t('purchase.bankTransfer.packageDetails.price', { price })}</p>
        </div>
      </div>

      <div className={styles.rows}>
        <h5 className={styles.title}>
          {t('purchase.bankTransfer.accountDetails.title')}
        </h5>
        <div className={styles.content}>
          <div className={styles.accountNumber}>
            {t('purchase.bankTransfer.accountDetails.account')}
            <span className={styles.big}>
              {t('purchase.bankTransfer.accountDetails.accountNumber')}
            </span>
            <img
              src={t('purchase.bankTransfer.accountDetails.bankImage')}
              className={styles.bankImage}
            />
          </div>
          <div className={styles.accountInfo}>
            {t('purchase.bankTransfer.accountDetails.accountTitle')}
            <span className={styles.accountOwner}>
              {t('purchase.bankTransfer.accountDetails.accountOwner')}
            </span>
          </div>
          <div className={styles.accountInfo}>
            {t('purchase.bankTransfer.accountDetails.bankTitle')}

            <span className={styles.bankName}>
              {t('purchase.bankTransfer.accountDetails.bankName')}
            </span>
          </div>
          <p>{t('purchase.bankTransfer.accountDetails.bankBranch')}</p>
        </div>
      </div>
      <div className={styles.rows}>
        <h5 className={styles.title}>
          {t('purchase.bankTransfer.paymentDetails.title')}
        </h5>
        <ul className={styles.paymentDetailList}>
          <li>{t('purchase.bankTransfer.paymentDetails.step1')}</li>
          <li>{t('purchase.bankTransfer.paymentDetails.step2')}</li>
        </ul>
      </div>

      <p className={styles.hint}>{t('purchase.bankTransfer.hint')}</p>
    </div>
  );
};

THBankTransfer.propTypes = {
  selectedPayment: object.isRequired,
  selectedPlan: object.isRequired,
  t: func.isRequired,
};

export default translate(['purchase'])(THBankTransfer);



// WEBPACK FOOTER //
// ./app/components/PaymentHandler/THBankTransfer/THBankTransfer.jsx